export default function ErrorBlock(
  props: IErrorBlockComponentProps,
): React.ReactElement {
  let msg: string;
  if (typeof props.blockObj.errorMessage === "string") {
    msg = props.blockObj.errorMessage;
  } else if (props.blockObj.errorMessage instanceof Error) {
    msg = props.blockObj.errorMessage.message;
  } else {
    msg = "Some unidentified error occurred";
  }

  return (
    <div className="sb-blockContent sb-error-inside-block">
      <span className="sb-error-inside-block-icon far fa-frown" />
      <div className="sb-error-inside-block-header">
        <h2>Aww, snap!</h2>
      </div>
      <div
        className="sb-error-inside-block-message"
        dangerouslySetInnerHTML={{ __html: msg }}
      />
    </div>
  );
}
